/**
 * 使用可能な色の設定
 */
const color = {
  // main
  primary: "#007E6C",
  white: "#FFF",
  // accent
  attention: "#EE8F00",
  attentionLight: "#FDF4E5",
  warning: "#DE4335",
  emphasis: "#CB1706",
  // text
  text: {
    black: "#23221F",
    gray: "#706D65",
    link: "#0071C1",
    linkDark: "#005A9A",
    linkLight: "#F2F8FC",
    disabled: "#C1BDB7",
  },
  background: "#F8F7F6",
  border: "#E5E5E5",
  footer: {
    background: "#EBECED",
  },
  form: {
    background: "#FBFBFB",
    border: "#A7A6A5",
    disabledBackground: "#E6E5E4",
  },
  table: {
    headerBackground: "#EDEBE8",
    headerBackgroundDark: "#E5E5E5",
  },
};

export default color;
